<template>
  <div class="my_enroll">
    <!-- title -->
    <div class="tit">
      <span>我的报名</span>
    </div>
    <!-- content -->
    <div class="body_content" v-if="user.role === 'UserRoleOrdinary'">
      <div class="btns">
        <div class="btn_left">
          <!-- <div class="tip">您目前为普通用户，请前往进行员工认证或者企业认证</div> -->
          <el-button type="primary" @click="employeeCertify">认证为员工</el-button>
          <el-button type="primary" @click="enterpriseCertify">认证为企业</el-button>
        </div>
      </div>
    </div>
    <div class="body_content" v-else>
      <myTable :tableObj="tableObj" @btnClick="btnClick" @changePageNo="getList"></myTable>
    </div>
  </div>
</template>

<script>
import myTable from '@/components/my_table.vue'
export default {
  data() {
    return {
      tableObj:{
        list:[],     //列表信息
        btns: [      //按钮组
          {
            name: "查看详情",
            funcName:'checkDetail'
          },      
          {
            name: "取消报名",
            funcName:'cancelEnroll',
            formatter: (row)=>{
              /* 获取当前时间戳 */ 
              var nowDate = new Date().getTime()
              /* 获取来访时间戳 */ 
              var startDate = new Date(row.start_date).getTime()
              /* 已提交状态 */ 
              var submitted = 'IdentityCertifieStatusSubmitted'
              /* 通过状态 */ 
              var success = 'IdentityCertifieStatussuccess'
              // 审核中或者审核成功并且在活动开始时间前则显示取消邀请
              return row.status === submitted || (row.status === success && nowDate < startDate)
            }
          },
          {
            name: "重新报名",
            funcName:'reEnroll',
            formatter: (row)=>{
              /* 获取当前时间戳 */ 
              var nowDate = new Date().getTime()
              /* 获取活动开始时间戳 */ 
              var startDate = new Date(row.start_date).getTime()
              // 已取消并且在活动开始前显示重新报名
              return row.status === 'IdentityCertifieStatusCancel' && startDate > nowDate
            }
          }
        ],
        table_detail: [//table详情
          {
            prop: "active_name",
            label: "活动信息",
            width:"120px",
             formatter:(row)=>{
              return `<a class="table_btn" href="#/garden_activity_details?id=${row.active_id}">${row.active_name}</a>`
            }
          },
          {
            prop: "active_type_name",
            label: "活动类型",
            width:"120px"
          },
          {
            prop: "active_address",
            label: "活动地点",
            width:"120px",
            formatter:(row)=>{
              return row.active_province_name + row.active_city_name+row.active_county_name
            }
          },
          {
            prop: "active_date",
            label: "活动时间",
            width:"250px",
             formatter:(row)=>{
              return  row.active_start_date+'—'+row.active_end_date
            }
          },
          {
            prop: "create_date",
            label: "报名时间",
            width:"150px"
          },
          {
            prop: "status_name",
            label: "审核状态",
          }
        ],
        layerpageinfo: {//分页
            pageNo: 0,
            total: 0,
            pageSize: 10,
        }
      },
      user:'',   //用户
      id:'',     //table行id
      
    };
  },
  components:{
    myTable
  },
  created(){
    if (this.$store.state.info) {
      this.initMsg(); /** 查询认证 用于二次编辑*/
    } else {
      this.needInfo("initMsg");
    }
  },
  computed: {
    info() {
      return this.$store.state.info;
    }
  },
  methods:{
    /* 获取报名列表 */ 
    getList(){
      let obj = {
        ...this.tableObj.layerpageinfo, 
      }
      this.api.getActiveSigns(obj)
      .then(res => {
        if (res.error.err_code != 0) return;
        let list = res.obj.list;
        this.tableObj.list =  res.obj.list || [];
        this.tableObj.layerpageinfo.total = res.obj.totalSize;
      })
      
    },
    // 初始化信息
    initMsg(){
      this.getList();
      this.user = this.$store.state.info;
    },
    btnClick(btn){
      // 已提交审核状态
      var submitted = 'IdentityCertifieStatusSubmitted';
      switch(btn.btnFuncName){
        // 查看详情
        case "checkDetail":
          this.$router.push({
            path:'/personal_center/park_user/my_enroll/my_enroll_detail',
            query:{
                id:btn.row.id
            }
          })
          break;
        // 取消报名
        case "cancelEnroll":
          console.log(btn.row)
          // 已提交状态，进行取消报名
          if(btn.row.status === submitted){ 
            this.$confirm('您正在取消报名, 是否继续?', '提示', {
              confirmButtonText: '继续',
              cancelButtonText: '再想想',
              type: 'warning'
            })
            .then(() => {
              this.id = btn.row.id
              this.cancelActive()
            })
            .catch(() => {
              return
            });
          }
        break;
        // 重新报名
        case "reEnroll":
          this.$router.push({
            path:'/garden_activity'
          })
        break;
        
      }
    },
    // 取消报名
    cancelActive(){
      let obj = {
        id:this.id,
      }
      this.api.cancelActive(obj)
      .then(res => {
        if(res.error.err_code != 0) return;
        this.$message({
          type: 'success',
          message: '取消成功！'
        });
        // 重新获取列表
        this.getList()
      })
    },
    needInfo(name) {
      let watchAch = this.$watch("info", (val, oldVal) => {
        if (val) {
          this[name]();
          watchAch(); //取消监听
        }
      });
    },
    // 员工认证
    employeeCertify(){
      this.$router.push({ name: "employee_certification" });
    },
    // 企业认证
    enterpriseCertify(){
      this.$router.push({ name: "enterprise_certification" });
    }
      
  }
};
</script>

<style lang="scss">
@import "../../../index.scss";
.my_enroll{
  .body_content{
    .btns{
      .btn_left{
        .tip{
          line-height: 40px;
          font-size: 16px;
        }
      }
    }
  }
}
</style>